/** Route for a user's followers or following list (`tab`: `followers` | `following`). */
export function followConnectionsPath(tab, userId) {
  if (userId) return `/profile/${userId}/${tab}`;
  return `/profile/${tab}`;
}
